import MuiLastPage from '@mui/icons-material/LastPage';
import { SvgIconProps } from '@mui/material/SvgIcon';

export type LastPageProps = SvgIconProps;

export const LastPage = (props: LastPageProps) => {
  return <MuiLastPage {...props} />;
};
